import {useState} from 'react';
import {Box, FormGroup, FormHelperText, FormLabel, Grid} from '@material-ui/core';
import {EditableInput, EditButton, FormFieldControl, Option} from './';
import getTranslated from '../locale/getTranslated';
import {FormattedMessage} from "react-intl";
import messages from "@super-template/messages";
import {Controller} from "react-hook-form";
import {without} from "lodash";
import ReactHtmlParser from 'react-html-parser';

export default ({options, name, isAdmin, control, fieldOptions = {}, required, locale, validate}) => {
  const [editing, setEditing] = useState(false);
  const description = getTranslated(fieldOptions.description, locale, true);
  const title = getTranslated(fieldOptions.title, locale);

  return editing ? <EditableInput fieldOptions={fieldOptions} close={() => setEditing(false)} id={name}/> :
    <Controller
      control={control} name={name} defaultValue={''} rules={isAdmin ? {} : {...validate, required}}
      render={({fieldState: {error}, field: {ref, onChange, ...field}}) =>
        <FormFieldControl required={required} error={!!error} component="fieldset" {...field}>
          <Box display="flex" justifyContent="space-between">
            <FormLabel component="label">{title}</FormLabel>
            {isAdmin && <EditButton onClick={() => setEditing(true)}/>}
          </Box>
          {description && <FormHelperText component="div" className={'description'} id={`${name}_description`}>
            {ReactHtmlParser(description)}
          </FormHelperText>}
          <FormGroup>
            <Grid container>
              {options.map((opt) =>
                <Grid item xs={12} sm={6} key={opt}>
                  <Option label={messages[opt]} disabled={isAdmin} value={opt} inputRef={ref} checked={field.value.includes(opt)} onChange={(e, b) => {
                    if(b) onChange([...field.value, opt]);
                    else onChange(without(field.value, opt))
                  }}/>
                </Grid>)}
            </Grid>
          </FormGroup>
          {error && <FormHelperText><FormattedMessage {...messages[error.type]}/></FormHelperText>}
        </FormFieldControl>}
    />
};
